import { DeviceDetailSection } from "@/features/devices/deviceDetailDisplay";

export type ConfirmedPlayerSettings = {
  volume: number | null;
  masterLevel: number | null;
  appLock: boolean | null;
  appLockPinSet: boolean | null;
  wakeSleepEnabled: boolean | null;
  startTime: string | null;
  endTime: string | null;
  /**
   * T24 — confirmed Fleet weekend-sleep flags. null/undefined = device has not
   * reported (NOT confirmed false). Never completeness-gating: older Players
   * may not report these.
   */
  sleepSaturday?: boolean | null;
  sleepSunday?: boolean | null;
};

export function confirmedPlayerSettingsFromDetail(
  player: DeviceDetailSection | null | undefined
): ConfirmedPlayerSettings {
  const volume = typeof player?.volume === "number" && Number.isFinite(player.volume)
    ? player.volume
    : null;
  const masterLevel =
    typeof player?.masterLevel === "number" && Number.isFinite(player.masterLevel)
      ? player.masterLevel
      : null;
  return {
    volume,
    masterLevel,
    appLock: typeof player?.appLock === "boolean" ? player.appLock : null,
    appLockPinSet:
      typeof player?.appLockPinSet === "boolean" ? player.appLockPinSet : null,
    wakeSleepEnabled:
      typeof player?.wakeSleepEnabled === "boolean" ? player.wakeSleepEnabled : null,
    startTime: typeof player?.startTime === "string" ? player.startTime : null,
    endTime: typeof player?.endTime === "string" ? player.endTime : null,
    sleepSaturday:
      typeof player?.sleepSaturday === "boolean" ? player.sleepSaturday : null,
    sleepSunday:
      typeof player?.sleepSunday === "boolean" ? player.sleepSunday : null,
  };
}

export function isCompleteConfirmedSettings(
  snap: ConfirmedPlayerSettings | null | undefined
): boolean {
  if (!snap) return false;
  if (snap.volume == null || snap.masterLevel == null) return false;
  if (snap.appLock == null || snap.appLockPinSet == null) return false;
  if (snap.wakeSleepEnabled == null) return false;
  if (snap.wakeSleepEnabled) {
    return Boolean(snap.startTime) && Boolean(snap.endTime);
  }
  return true;
}
